import React from "react";
import { useLocation, useHistory, Route } from 'react-router';
import Logo from "../../assets/img/logo-tla-left-light.svg";
import DefaultAvatar from '../../assets/imgs/download.png';
import { checkIsActive } from '../../utils/constant';
import "./style.css"
import { NavLink } from 'react-router-dom';


const AppMainNavigation = () => {
  const [loginData, setLoginData] = React.useState({
    firstName: localStorage.getItem('fName'),
    role: localStorage.getItem('__r'),
    lastName: localStorage.getItem('lName'),
    avatar: localStorage.getItem('avatar'),
  });

  let history = useHistory();
  const location = useLocation();

  const renderUserRole = () => {
    let role = 'Admin';
    if (loginData.role === 'frontdesk') {
      role = 'Frontdesk';
    } else if (loginData.role === 'event') {
      role = 'Events';
    }
    return role;
  };

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url) ? "active" : "";
  };

  const ROUTE = {
    dashboard: `/${loginData.role}/dashboard`,
    appointment: `/${loginData.role}/appointments`,
    calendar: `/${loginData.role}/calendar`,
    users: `/${loginData.role}/patients`,
    invoices: `/${loginData.role}/billing`,
    timeSlots: `/${loginData.role}/time-slots`,
    clinicNotes: `/${loginData.role}/time-slots`,
    clinicNotesMissing: `/${loginData.role}/appointments?status=ended`,
    wailist: `/${loginData.role}/appointments?status=waiting`,
    archived: `/${loginData.role}/appointments?status=archived`,
    cancelled: `/${loginData.role}/appointments?status=cancelled`,
    noShow: `/${loginData.role}/appointments?status=missed`,
    sessionEnded: `/${loginData.role}/appointments?status=ended`,
    referred: `/${loginData.role}/appointments?status=reffered`,
    upcoming: `/${loginData.role}/appointments?status=upcoming`,
    staffMember: `/${loginData.role}/staff-members`,
    reports: `/${loginData.role}/reports`,
    serviceBundles: `/${loginData.role}/service-bundles`,
    corporation: `/${loginData.role}/corporation`,
    consentForm: `/${loginData.role}/consent-forms`,
    serviceType: `/${loginData.role}/service-type`,
    clinicAddresses: `/${loginData.role}/clinic-addresses`,
    sendSms: `/${loginData.role}/send-sms`,
    eventsUpcoming: `/${loginData.role}/events?status=upcoming`,
    eventsPrevious: `/${loginData.role}/events?status=previous`,
    eventCategories: `/${loginData.role}/events/categories`,
    eventTriggers: `/${loginData.role}/events/triggers`,
    siteWideTrigger: `/${loginData.role}/triggers`,
  }

  return (
    <div className="bg-brand-blue-light leading-normal">
      { }
      <nav className="relative h-17 w-full border shadow-sm bg-white xl:hidden">
        <div className="flex justify-between items-center">
          { }
          <div className="logo text-center ml-0.5 p-3">
            <img
              className="inline-block h-10"
              src={Logo}
              alt
              width="auto"
            />
          </div>
          { }
          <div className="mr-6">
            <button className="btn-open-primary-menu p-2 rounded border bg-gray-100 hover:bg-gray-50">
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </nav>
      { }
      <nav className="primary-menu-wrapper hidden absolute inset-0 bg-gray-700 bg-opacity-50 z-50 xl:relative xl:bg-transparent xl:block">
        { }
        <div className="relative flex flex-col w-72 h-screen bg-white border shadow-sm z-50 xl:w-full xl:h-full xl:flex-row xl:justify-between xl:items-center">
          { }
          <button className="btn-close-primary-menu absolute top-5 -right-10 xl:hidden">
            <svg
              className="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          { }
          <div className="logo text-center p-3">
            <img
              className="inline-block h-10"
              src={Logo}
              alt
              width="auto"
            />
          </div>
          { }
          {/* TODO: Fix hatiham */}
          <div className="menu-staff-profile">
            <div className="flex flex-col flex-nowrap xl:flex-row xl:justify-end xl:mr-6 xl:items-center">
              { }
              <div className="inline-block relative h-16 w-16 mb-2 self-center xl:order-2 xl:flex-shrink-0 xl:w-10 xl:h-10 xl:ml-2 xl:mb-0">
                <img
                  className="h-16 w-16 rounded-full border xl:w-10 xl:h-10"
                  src={loginData.avatar ? loginData.avatar : DefaultAvatar}
                  alt
                />
                <span className="absolute top-0 right-0 h-4 w-4 rounded-full ring-2 ring-white bg-green-400 xl:w-2 xl:h-2"></span>
              </div>
              { }
              <div className="inline-block text-center xl:order-1 xl:text-right">
                <span className="block text-base font-medium leading-1 xl:text-sm">
                  {loginData.firstName
                    ? loginData.firstName + ' ' + loginData.lastName
                    : ''}
                </span>
                <span className="user-role">
                  {renderUserRole()}
                </span>
              </div>
            </div>
          </div>
          <nav className="menu-top-level">
            { }
            <ul className="primary-menu xl:flex xl:justify-start xl:items-center xl:gap-1">
              <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.dashboard)}`}>
                <NavLink
                  exact
                  activeClassName="navbar__link--active"
                  className="navbar__link"
                  to={ROUTE.dashboard}
                >
                  <span className="menu-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                      />
                    </svg>
                  </span>
                  <span data-config-id="link5">Dashboard</span>
                </NavLink>
              </li>
              <li className="menu-item-top-level">
                <a href="javascript:void(0)">
                  <span className="menu-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </span>
                  <span className="text-sm font-medium">Appointments</span>
                  <span className="inline-block ml-auto xl:ml-1">
                    <svg
                      className="icon-more h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </span>
                </a>
                { }
                <ul className="submenu">
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.calendar)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.calendar}
                    >
                      Calendar
                    </NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.timeSlots)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.timeSlots}
                    >
                      Time Slots
                    </NavLink>
                  </li>
                  <li>
                    <hr className="my-2" />
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.clinicNotes)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.clinicNotes}
                    >
                      Clinical Note Completed
                    </NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.clinicNotesMissing)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.clinicNotesMissing}
                    >
                      Clinical Note Missing
                    </NavLink>
                  </li>
                  <li>
                    <hr className="my-2" />
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.upcoming)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.upcoming}
                    >
                      Upcoming
                    </NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.wailist)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.wailist}
                    >
                      Waiting List
                    </NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.archived)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.archived}
                    >
                      Archived
                    </NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.cancelled)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.cancelled}
                    >
                      Cancelled
                    </NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.noShow)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.noShow}
                    >
                      No Show
                    </NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.sessionEnded)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.sessionEnded}
                    >
                      Session Ended
                    </NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.referred)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.sessionEnded}
                    >
                      Referred
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="menu-item-top-level">
                <a href="javascript:void(0)">
                  <span className="menu-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  </span>
                  <span>Users</span>
                  <span className="inline-block ml-auto xl:ml-1">
                    <svg
                      className="icon-more h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </span>
                </a>
                { }
                <ul className="submenu">
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.users)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.users}
                    >Clients</NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.staffMember)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.staffMember}
                    >Staff Members</NavLink>
                  </li>
                </ul>
              </li>
              <li class="menu-item-top-level active" data-component="events">
                <a href="javascript:void(0)">
                  <span class="menu-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </span>
                  <span>Events</span>
                  <span class="inline-block ml-auto xl:ml-1">
                    <svg class="icon-more h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </a>

                <ul class="submenu">
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.eventsUpcoming)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.eventsUpcoming}
                    >
                      Upcoming Events</NavLink></li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.eventsPrevious)}`}><NavLink
                    exact
                    activeClassName="navbar__link--active"
                    className="navbar__link"
                    to={ROUTE.eventsPrevious}
                  >Previous Events</NavLink></li>
                  <li><hr class="my-2" /></li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.eventCategories)}`}><NavLink
                    exact
                    activeClassName="navbar__link--active"
                    className="navbar__link"
                    to={ROUTE.eventCategories}
                  >Events Categories</NavLink></li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.eventTriggers)}`}><NavLink
                    exact
                    activeClassName="navbar__link--active"
                    className="navbar__link"
                    to={ROUTE.eventTriggers}
                  >Triggers & Templates</NavLink></li>
                </ul>
              </li>
              <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.invoices)}`}>
                <NavLink
                  exact
                  activeClassName="navbar__link--active"
                  className="navbar__link"
                  to={ROUTE.invoices}
                >
                  <span className="menu-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  </span>
                  <span>Invoices</span>
                  { }
                </NavLink>
              </li>
              <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.reports)}`}>
                <NavLink
                  exact
                  activeClassName="navbar__link--active"
                  className="navbar__link"
                  to={ROUTE.reports}
                >
                  <span className="menu-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                      />
                    </svg>
                  </span>
                  <span>Reports</span>
                  { }
                </NavLink>
              </li>
              <li className="menu-item-top-level">
                <a href="javascript:void(0)">
                  <span className="menu-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
                      />
                    </svg>
                  </span>
                  <span>More</span>
                  <span className="inline-block ml-auto xl:ml-1">
                    <svg
                      className="icon-more h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </span>
                </a>
                { }
                <ul className="submenu">
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.serviceBundles)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.serviceBundles}
                    >Service Bundles</NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.corporation)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.corporation}
                    >Corporate Clients</NavLink>
                  </li>
                  <li>
                    <hr className="my-2" />
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.consentForm)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.consentForm}
                    >Consent Forms</NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.serviceType)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.serviceType}
                    >Service Type VAT</NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.clinicAddresses)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.clinicAddresses}
                    >Clinicial Addresses</NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.sendSms)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.sendSms}
                    >SMS</NavLink>
                  </li>
                  <li className={`menu-item-top-level ${getMenuItemActive(ROUTE.siteWideTrigger)}`}>
                    <NavLink
                      exact
                      activeClassName="navbar__link--active"
                      className="navbar__link"
                      to={ROUTE.siteWideTrigger}
                    >Site Wide Triggers</NavLink>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </nav>
    </div>
  );
}
export default AppMainNavigation;